import React from "react";
import PropTypes from "prop-types";
// import IconLinksSelection from "./IconLinksSelection";
// eslint-disable-next-line import/no-cycle
import { IconLinksChecks } from "./IconLinksChecks";
// eslint-disable-next-line import/no-cycle
import { IconContentSelection } from "./IconContentSelection";
import { RCL as useTranslation } from "../RCL";
import { LOCAL_EN, LOCAL_FR } from "../../const/const";

const IconLinksConnector = ({ data, locale }) => {
	const language = locale.slice(0, 2);

	const defaultLabels = {
		from: "From",
		to: "To",
	};

	const labels = {
		from: useTranslation({ searchKey: "from" }) || defaultLabels.from,
		to: useTranslation({ searchKey: "to" }) || defaultLabels.to,
	};

	switch (data.variant) {
		case "linkWithLeftIcon":
			return <IconLinksChecks links={data.linkEntries} />;
		case "link":
		case "tile":
		case "tilePricing":
		case "paragraph":
		case "paragraphNoIcon":
			return (
				<IconContentSelection
					links={data.linkEntries}
					columns={data.columns}
					variant={data.variant}
					customVariant={data.customVariant}
					labels={labels}
					language={language}
				/>
			);
		default:
			return <></>;
	}
};
IconLinksConnector.propTypes = {
	data: PropTypes.shape({
		title: PropTypes.string,
		linkEntries: PropTypes.arrayOf(PropTypes.object),
		placeIconAboveText: PropTypes.bool,
		columns: PropTypes.string,
		variant: PropTypes.string,
		customVariant: PropTypes.string,
	}),
	locale: PropTypes.oneOf(LOCAL_EN, LOCAL_FR),
};
IconLinksConnector.defaultProps = {
	data: null,
	locale: LOCAL_EN,
};

export default IconLinksConnector;
export { IconLinksConnector };
